import _ from 'lodash';
import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';

import cz from './resources/cz.json';
import en from './resources/en.json';
import sl from './resources/sl.json';

export type LanguageOption = {
  code: string;
  value: string;
  label: string;
};

export const DEFAULT_LANGUAGE_OPTION: LanguageOption = {code: 'us', value: 'en', label: 'English'};
export const LANGUAGES_OPTIONS: LanguageOption[] = _.sortBy(
  [
    DEFAULT_LANGUAGE_OPTION,
    {code: 'cz', value: 'cz', label: 'Čeština'},
    {code: 'si', value: 'sl', label: 'Slovensko'},
  ],
  'label',
);

const resources = {
  en: {translation: en},
  sl: {translation: sl},
  cz: {translation: cz},
};

const STORAGE_KEY = 'user-manual-language';

const readStored = (): string | null => {
  try {
    return localStorage.getItem(STORAGE_KEY);
  } catch {
    // eslint-disable-next-line no-console
    console.warn('localStorage for language selection is unavailable.');
    try {
      return sessionStorage.getItem(STORAGE_KEY);
    } catch {
      return null;
    }
  }
};

const writeStored = (value: string): void => {
  try {
    localStorage.setItem(STORAGE_KEY, value);
  } catch {
    // eslint-disable-next-line no-console
    console.warn('localStorage for language selection is unavailable.');
    try {
      sessionStorage.setItem(STORAGE_KEY, value);
    } catch {
      // both stores unavailable; language will not persist
    }
  }
};

const getLanguage = (): string => readStored() ?? DEFAULT_LANGUAGE_OPTION.value;

export const setLanguage = (value: string): void => {
  writeStored(value);
  void i18n.changeLanguage(value);
};

i18n.use(initReactI18next).init({
  compatibilityJSON: 'v4',
  lng: getLanguage(),
  fallbackLng: DEFAULT_LANGUAGE_OPTION.value,
  ns: 'translation',
  defaultNS: 'translation',
  react: {useSuspense: false},
  interpolation: {escapeValue: false},
  resources,
});

export default i18n;
